export default function fetchCss() {
  return new Promise(resolve => {
    const style = document.createElement('link')
    style.href = process.env.CDN_CSS
    style.rel = 'stylesheet'
    document.head.appendChild(style)

    style.onload = () => {
      resolve()
    }
    style.onerror = () => {
      // proceed without styles.
      resolve()
    }
  })
}
